import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';
import { TokenProviderService } from '../util-token-provider';

/**
 * Creates an auth interceptor that adds Bearer token to requests matching specified URL providers.
 * Each app should call this factory with only the URL providers it actually uses.
 */
export function createAuthInterceptor(urlProviderTokens: InjectionToken<() => string>[]): HttpInterceptorFn {
  return (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const tokenProvider = inject(TokenProviderService);
    const rmaApiUrls = urlProviderTokens.map((token) => inject(token)());

    if (rmaApiUrls.some((url) => req.url.startsWith(url))) {
      const token = tokenProvider.getUserToken();

      if (token) {
        req = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${token}`),
        });
      }
    }
    return next(req);
  };
}
